import gql from 'graphql-tag'

export const GET_FUTURE_SESSIONS = gql`
  query GetFutureSessions($StudentProfileId: String!, $InstructorId: String!, $ProgramId: String) {
    getFutureSessions(StudentProfileId: $StudentProfileId, InstructorId: $InstructorId, ProgramId: $ProgramId) {
      Sessions
      Next24Hours
    }
  }
`
